import { Component, inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { RulesService } from "src/app/services/rules/rules.service";
@Component({
	selector: "app-confirm-edit-rule-dialog",
	templateUrl: "./confirm-edit-rule-dialog.component.html",
	styleUrls: ["./confirm-edit-rule-dialog.component.scss"],
})
export class ConfirmEditRuleDialogComponent implements OnInit {
	constructor(public dialogRef: MatDialogRef<ConfirmEditRuleDialogComponent>, private rulesService: RulesService) {}

	data = inject<number>(MAT_DIALOG_DATA);

	ngOnInit(): void {}

	confirmEdit() {
		this.rulesService.confirmEditRule$.next();
		this.dialogRef.close();
	}
}
